import { currentLanguage, getStorageValue } from "../../../algorithms/storage";
import axios from "../../axiosConfig";

export const getProjects = (communityId, pageNo = 1, pageCount = 10, token) => {
  return axios.get(
    `Project/GetProjects/${communityId}/${pageNo}/${pageCount}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getProjectForm = (communityID, token) => {
  return axios.get(`Project/GetProjectForm/${communityID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getProjectFormSearch = (communityID, token) => {
  return axios.get(`Project/GetProjectFormSearch/${communityID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getProjectCounts = (communityID, token) => {
  return axios.get(`Task/GetStatusCount/${communityID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getActivityForm = (projectID, token) => {
  return axios.get(`Activity/GetActivityForm/${projectID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getProjectStatus = (token) => {
  return axios.get(`Project/GetProjectStatus`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getProjectMembers = (projectId, token) => {
  return axios.get(`Project/GetProjectMember/${projectId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const setProjMemberStatus = (id, statusId, token) => {
  return axios.put(`Project/SetMemberStatus/${id}/${statusId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      // Authorization: `Bearer ${token}`,
    },
  });
};

export const setProjStatus = (projectId, statusId, cahngeAll, token) => {
  return axios.put(
    `Project/SetProjectStatus/${projectId}/${statusId}/${cahngeAll}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        // Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const addProject = (data, token) => {
  return axios.post("Project/AddProject", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addMilestone = (data, token) => {
  return axios.post("Milestone/AddMilestone", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getMilestones = (projectId, pageNumber, pageSize, token) => {
  return axios.get(
    `Milestone/GetMilestones/${projectId}/${pageNumber}/${pageSize}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const deleteMil = (milestoneId, token) => {
  return axios.delete(`Milestone/DeleteMilestone/${milestoneId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEditMilestoneForm = (milestoneId, projectId, token) => {
  return axios.get(
    `Milestone/GetEditMilestoneForm/${milestoneId}/${projectId}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const updateMilestone = (data, token) => {
  return axios.put("Milestone/UpdateMilestone", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getProject = (projectId, token) => {
  return axios.get(`Project/GetProject?ProjectId=${projectId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getActivity = (activityId, token) => {
  return axios.get(`Activity/Details/${activityId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getActivityAttachments = (activityId, token) => {
  return axios.get(`Activity/GetAllActivityAttachment/${activityId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getProjectAttachments = (
  projectId,
  pageNo = 1,
  pageCount = 10,
  token
) => {
  return axios.get(
    `Project/GetProjectAttachments/${projectId}/${pageNo}/${pageCount}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getEditProjectForm = (projectId, communityId, token) => {
  return axios.get(`Project/GetEditProjectForm/${projectId}/${communityId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEditActivityForm = (activityId, communityId, token) => {
  return axios.get(
    `Activity/GetEditActivityForm/${activityId}/${communityId}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const updateProject = (data, communityId, token) => {
  return axios.put(`Project/UpdateProject?communityId=${communityId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteProj = (projId, token) => {
  return axios.delete(`Project/DeleteProject/${projId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteAct = (actId, token) => {
  return axios.delete(`Activity/DeleteActivity/${actId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const setStatus = (id, statusId, token) => {
  return axios.put(`Activity/SetActivityMemberStatus/${id}/${statusId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      // Authorization: `Bearer ${token}`,
    },
  });
};

export const setActivitiesStatus = (activityId, statusId, cahngeAll, token) => {
  return axios.put(
    `Activity/SetActivityStatus/${activityId}/${statusId}/${cahngeAll}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        // Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getActivityMembers = (activityId, token) => {
  return axios.get(`Activity/GetActivityMember/${activityId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getActivityProcedureForm = (activityId, token) => {
  return axios.get(`ActivityProcedure/GetActivityProcedureForm/${activityId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addActivityProcedureForm = (data, token) => {
  return axios.post(`ActivityProcedure/AddActivityProcedure`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEditProcedure = (porcId, token) => {
  return axios.get(`ActivityProcedure/GetEditActivityProcedureForm/${porcId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addActivity = (data, token) => {
  return axios.post(`Activity/AddActivity`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteActivityProc = (procId, token) => {
  return axios.delete(`ActivityProcedure/DeleteActivityProcedure/${procId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getActivityStatus = (token) => {
  return axios.get("Activity/GetProjectStatus", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Language": currentLanguage(),
    },
  });
};

export const editActivityProcStatus = (procId, statusId, token) => {
  return axios.put(
    `ActivityProcedure/SetActivityProcedureStatus/${procId}/${statusId}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const searchProjects = (
  communityID,
  pageNumber = 1,
  pageSize = 4,
  data = {},
  token
) => {
  return axios.post(
    `Project/Search/${communityID}/${pageNumber}/${pageSize}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": getStorageValue("language"),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
